@if (showTable && config.tableVersion !== 2) {
<aw-table [data]="data" [config]="config" (select)="onSelect($event)" (click)="click($event)"></aw-table>
} @if (showTable && config.tableVersion === 2) {
<aw-table-2 [config]="config.tableConfig" [request]="config.request" (rowClick)="click($event)" (rowSelect)="onSelect($event)"></aw-table-2>
}
